import React from 'react';
import { Quote } from 'lucide-react';
import { SlideLayout } from '../SlideLayout';
interface SlideProps {
  isActive: boolean;
  currentSlide: number;
  totalSlides: number;
  onNext: () => void;
  onPrev: () => void;
}
export function ProspectTestimonialsSlide(props: SlideProps) {
  return <SlideLayout {...props} title="Loved by Educators" subtitle="Join thousands of teachers and professors saving time with EduAssess." data-id="element-340">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-12" data-id="element-341">
        <div className="bg-slate-50 p-8 rounded-3xl relative" data-id="element-342">
          <Quote className="w-10 h-10 text-indigo-200 absolute top-6 right-6" data-id="element-343" />
          <p className="text-slate-700 mb-6 relative z-10 leading-relaxed" data-id="element-344">
            "EduAssess cut my assessment prep time by 90%. I can finally focus
            on teaching instead of formatting documents all weekend."
          </p>
          <div className="flex items-center gap-3" data-id="element-345">
            <div className="w-10 h-10 rounded-full bg-indigo-100 flex items-center justify-center font-bold text-indigo-600" data-id="element-346">
              SM
            </div>
            <div data-id="element-347">
              <div className="font-bold text-slate-900" data-id="element-348">Sarah M.</div>
              <div className="text-xs text-slate-500" data-id="element-349">
                High School Science Teacher
              </div>
            </div>
          </div>
        </div>

        <div className="bg-slate-50 p-8 rounded-3xl relative" data-id="element-350">
          <Quote className="w-10 h-10 text-indigo-200 absolute top-6 right-6" data-id="element-351" />
          <p className="text-slate-700 mb-6 relative z-10 leading-relaxed" data-id="element-352">
            "The ability to generate questions directly from YouTube videos is a
            game changer for my flipped classroom model."
          </p>
          <div className="flex items-center gap-3" data-id="element-353">
            <div className="w-10 h-10 rounded-full bg-emerald-100 flex items-center justify-center font-bold text-emerald-600" data-id="element-354">
              JD
            </div>
            <div data-id="element-355">
              <div className="font-bold text-slate-900" data-id="element-356">James D.</div>
              <div className="text-xs text-slate-500" data-id="element-357">University Professor</div>
            </div>
          </div>
        </div>

        <div className="bg-slate-50 p-8 rounded-3xl relative" data-id="element-358">
          <Quote className="w-10 h-10 text-indigo-200 absolute top-6 right-6" data-id="element-359" />
          <p className="text-slate-700 mb-6 relative z-10 leading-relaxed" data-id="element-360">
            "We use it for all our corporate training compliance tests. It
            ensures consistency and saves our HR team weeks of work."
          </p>
          <div className="flex items-center gap-3" data-id="element-361">
            <div className="w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center font-bold text-amber-600" data-id="element-362">
              EL
            </div>
            <div data-id="element-363">
              <div className="font-bold text-slate-900" data-id="element-364">Elena L.</div>
              <div className="text-xs text-slate-500" data-id="element-365">Training Manager</div>
            </div>
          </div>
        </div>
      </div>
    </SlideLayout>;
}